import { gql } from '@apollo/client';

export const GET_ALL_PAYROLL_COMMUNICATIONS = gql`
  query GetAllPayrollCommunicationsTracking($onlyWithPaymentDate: Boolean) {
    getAllPayrollCommunicationsTracking(onlyWithPaymentDate: $onlyWithPaymentDate) {
      pcId
      pctId
      payrollCompany {
        pcIdeNum
        tiId
        typeIdentity {
          tiId
          tiPrefix
        }
        payrollStaff {
          psFirNam
          psSecNam
          psFirLas
          psSecLas
        }
      }
      typeOfCall {
        tcId
        tcName
      }
      pctDate
      pctTime
      pctPhone
      pctDescription
      pctDatePaymentCommitment
    }
  }
`;
